export default __webpack_public_path__ + "static/media/gallery_02.8995c1bc.jpg";